import TrueArrow from "../../../assets/Images/true.svg";
import { registeringForm } from "../../../utils/string";
const PricingCard = ({ item }) => {
  return (
    <div className="rounded-lg" style={{ boxShadow: "0px 0px 50px 0px #0000001A" }}>
      <div className="bg-black pt-[30px] rounded-t-lg text-center relative pb-[65px]">
        <div className="text-[32px] font-[Roboto] text-white font-medium">{item.title}</div>
        <div className="text-[24px] font-[Roboto] text-white font-medium">{item.subTitle}</div>
        <div className="absolute bottom-[-44px] w-[-webkit-fill-available] flex items-center justify-center">
          <div
            className="bg-[#FEBA06] border-[5px] border-white font-semibold text-[22px] font-[Roboto] w-[88px] h-[88px] rounded-full flex items-center justify-center  text-[#161412]"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
          >
            {item.price}
          </div>
        </div>
      </div>
      <div className="bg-white px-[20px] rounded-b-lg mt-[78px]">
        <div>
          {item.list.map((listTime) => {
            return (
              <div className="flex text-[14px] font-[Roboto] font-normal my-[10px] text-[#161412]">
                <img src={TrueArrow} alt="" className="mr-[10px]" />
                {listTime}
              </div>
            );
          })}
        </div>

        <button
          type="submit"
          className="border border-[#FEBA06] bg-[#FEBA06] py-[15px] font-bold text-[16px] font-bold font-[Roboto] rounded-lg w-full mt-[50px] mb-[15px]  text-[#161412]"
        >
          {registeringForm.SELECT_PLAN}
        </button>
      </div>
    </div>
  );
};
export default PricingCard;
